import { useProfileContext } from "@hooks/context/useProfileContext";
import { ProfileType } from "@interfaces/profile";
import { ProjectLoader } from "@stories/atoms/Loaders/ProjectLoader/ProjectLoader";
import { Account } from "@stories/pages/Account/Account";
import { AdminAccount } from "@stories/pages/Account/AdminAccount";

export const AccountView = () => {
  const { isProfileLoading, userProfile } = useProfileContext();

  if (isProfileLoading) {
    console.log("ACCOUNT View PAGE LOADER");
    return <ProjectLoader />;
  }

  if (userProfile) {
    return userProfile.type === ProfileType.Admin ? (
      <AdminAccount />
    ) : (
      <Account />
    );
  }
  return <AdminAccount />;
};
